import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './SiteSettings.css';

// Component
import SiteSettingsForm from '../../../components/siteadmin/SiteSettingsForm';
import Loader from '../../../components/Loader';

// Query
import siteSettingsQuery from './siteSettingsQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

class SiteSettings extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      siteSettings: PropTypes.array,
    })
  };

  static defaultProps = {
    data: {
      loading: true
    }
  };


  render() {
    const { data: { loading, siteSettings } } = this.props;
    let settingsCollection = {};
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      siteSettings.map((item, key) => {
        settingsCollection[item.name] = item.value;
      });
      return <SiteSettingsForm initialValues={settingsCollection} />
    }
  }

}

export default compose(
  withStyles(s),
  withQuery(siteSettingsQuery,
    {
      options: (props) => ({
        variables: {
          type: 'site_settings',
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(SiteSettings);
